import { MouseEvent } from 'react';
import { CTContainer } from '../styles';

interface ITopCTA {
  onClickCB: (e: MouseEvent<Element, MouseEvent>) => void;
  CTA: string;
}
export const TopCTA: React.FC<ITopCTA> = ({ onClickCB, CTA }) => {
  return (
    <CTContainer>
      <div
        onClick={(e) =>
          onClickCB(e as unknown as MouseEvent<HTMLDivElement, MouseEvent>)
        }
        data-testid="topCta"
        dangerouslySetInnerHTML={{ __html: CTA || '' }}
      />
    </CTContainer>
  );
};
